export class AutomotiveAftermarketFiltersDictionaryLoad {
  public static readonly type = '[AutomotiveAftermarketFiltersDictionary] Load';
}

export class AutomotiveAftermarketFiltersDictionaryInitialState {
  public static readonly type = '[AutomotiveAftermarketFiltersDictionary] Set Initial State';
}
